"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCustomConnectorConfiguration = void 0;
const extractors_1 = require("../extractors");
const connectors_1 = require("./connectors");
/**
 * Create configuration for a connector whose runtime data is read from request body (POST)
 *
 * @param id connector id
 * @param accountId account id
 * @param name connector name
 * @param customConfiguration custom extractor (online extractor) configuration
 * @param elements connectors elements
 */
function createCustomConnectorConfiguration(id, accountId, name, customConfiguration, elements) {
    const dummyOfflineExtractorConfiguration = {
        version: 1,
        type: extractors_1.ExtractorType.Dummy,
        UIDFieldName: "id"
    };
    // Create connector configuration and instantiate it.
    return {
        version: 1,
        type: connectors_1.ConnectorType.Custom,
        id,
        offlineExtractor: dummyOfflineExtractorConfiguration,
        runtimeExtractor: customConfiguration,
        name,
        accountId,
        elements: elements === null || elements === void 0 ? void 0 : elements.map(e => e.serialize())
    };
}
exports.createCustomConnectorConfiguration = createCustomConnectorConfiguration;
//# sourceMappingURL=customConnector.js.map